import { Component, Input, OnInit } from "@angular/core";
import { ApiService } from "src/app/services/api.service";
import { environment } from "src/environments/environment";

interface FAQItem {
  title: string;
  answer: string;
  expanded: boolean;
}

interface FAQSInterface {
  faqs: string;
}

@Component({
  selector: "app-faqs",
  templateUrl: "./faqs.component.html",
  styleUrls: ["./faqs.component.scss"],
})
export class FAQSComponent implements OnInit {
  items: FAQItem[];

  @Input() node: FAQSInterface;

  constructor(private API: ApiService) {}

  expandItem(item: FAQItem): void {
    if (item.expanded) {
      item.expanded = false;
    } else {
      this.items?.map((listItem) => {
        if (item == listItem) {
          listItem.expanded = !listItem.expanded;
        } else {
          listItem.expanded = false;
        }
        return listItem;
      });
    }
  }

  ngOnInit() {
    if (this.node.faqs) {
      this.API.GET(
        `public/faqs/${environment.mall_id}/${this.node.faqs}`
      ).subscribe({
        next: (response) => {
          this.items = response;
        },
        error: (response) => {},
      });
    }
  }
}
